import { useRef, useCallback } from "react";

const useRingTone = () => {
  const audioCtxRef = useRef<AudioContext | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const isPlayingRef = useRef(false);

  const playRingCycle = useCallback(() => {
    if (!audioCtxRef.current) return;
    const ctx = audioCtxRef.current;

    // Türk telefon zil sesi: 440Hz + 480Hz karışımı, 2sn çal 4sn dur
    const playBeep = (startTime: number, duration: number) => {
      const osc1 = ctx.createOscillator();
      const osc2 = ctx.createOscillator();
      const gainNode = ctx.createGain();

      osc1.type = "sine";
      osc1.frequency.setValueAtTime(440, startTime);

      osc2.type = "sine";
      osc2.frequency.setValueAtTime(480, startTime);

      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(0.3, startTime + 0.05);
      gainNode.gain.setValueAtTime(0.3, startTime + duration - 0.05);
      gainNode.gain.linearRampToValueAtTime(0, startTime + duration);

      osc1.connect(gainNode);
      osc2.connect(gainNode);
      gainNode.connect(ctx.destination);

      osc1.start(startTime);
      osc1.stop(startTime + duration);
      osc2.start(startTime);
      osc2.stop(startTime + duration);
    };

    const now = ctx.currentTime;
    // 0.0 - 2.0sn çal
    playBeep(now, 2.0);
    // 2.0 - 4.0sn sessiz (interval ile tekrar)
  }, []);

  const start = useCallback(() => {
    if (isPlayingRef.current) return;
    isPlayingRef.current = true;

    try {
      audioCtxRef.current = new AudioContext();
      playRingCycle();

      // Her 4 saniyede bir tekrar çal (2sn çal + 2sn sessiz)
      intervalRef.current = setInterval(() => {
        if (audioCtxRef.current && isPlayingRef.current) {
          playRingCycle();
        }
      }, 4000);
    } catch {
      // AudioContext desteklenmiyor
    }
  }, [playRingCycle]);

  const stop = useCallback(() => {
    isPlayingRef.current = false;

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (audioCtxRef.current) {
      audioCtxRef.current.close().catch(() => {});
      audioCtxRef.current = null;
    }
  }, []);

  return { start, stop };
};

export default useRingTone;
